import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router";
import {LoadingState} from "../../../components/fouladyar/loading-state/loadingState";
import axios from "axios";
import {ErrorToaster, SuccessToaster} from "../../../shared/toaster";
import ModalHelper from "../../../components/fouladyar/modal-helper/modalHelper";
import {Field} from "../../../components/fouladyar/field/field";
import {useTranslation} from "react-i18next";
// import {
//     BarElement,
//     CategoryScale,
//     Chart as ChartJS,
//     Legend,
//     LinearScale,
//     LineElement,
//     PointElement,
//     Tooltip
// } from 'chart.js';
import {Progress} from "../../../components/Component";
import TotalProfitAndLossVerticalLineChartComponent from "./charts/TotalProfitAndLossVerticalLineChartComponent";
import SymbolsDoughnutChartComponent from "./charts/SymbolsDoughnutChartComponent";
import ProfitMAEScatterRedChartComponent from "./charts/ProfitMAEScatterRedChartComponent";
import ProfitMFEScatterBlueChartComponent from "./charts/ProfitMFEScatterBlueChartComponent";
import NumberOfTradesCompoLineAndBarChartComponent from "./charts/NumberOfTradesCompoLineAndBarChartComponent";
import HighestAndLowestPnlLineChartComponent from "./charts/HighestAndLowestPnlLineChartComponent";
import LongOrShortCountDoughnutChartComponent from "./charts/LongOrShortCountDoughnutChartComponent";
import GrowthLineChartComponent from "./charts/GrowthLineChartComponent";
import MaximumDrawdownInSingleDayLineChartComponent from "./charts/MaximumDrawdownInSingleDayLineChartComponent";
import {IoMdCheckmarkCircle} from "react-icons/io";
import {IoCloseSharp} from "react-icons/io5";
import {ConvertGregorianToJalali} from "../../../shared/convertGregorianToJalali";
import moment from "moment";
import TradesByHoursLineChartComponent from "./charts/TradesByHoursLineChartComponent";
import TradesByDayOfWeekLineChartComponent from "./charts/TradesByDayOfWeekLineChartComponent";
import TradesByMonthLineChartComponent from "./charts/TradesByMonthLineChartComponent";
import {EmptyState} from "../../../components/fouladyar/empty-state/emptyState";
import {MdOutlineCandlestickChart} from "react-icons/md";
import './analytics.css'
import {Divider} from "../../fxpilot/signal/tabs/signals";
import AnalyticsLogs from "../logs/analytics-logs";
import {TbAlertTriangle} from "react-icons/tb";

// ChartJS.register(BarElement, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const Analytics = () => {
    const auth = useSelector((state) => state.auth);

    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const {id, review_id, metaapi_server} = useParams();
    const [activeTab, setActiveTab] = useState('tab1');
    const profileState = useSelector((state) => state.profile);
    const [modalComponent, setModalComponent] = useState(<div> empty </div>);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingAccounts, setLoadingAccounts] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [loadingOrderDetails, setLoadingOrderDetails] = useState(false);
    const dispatch = useDispatch();

    const [accounts, setAccounts] = useState([]);
    const [mainUser, setMainUser] = useState({
        fullName: '',
        email: ''
    });
    const [orderId, setOrderId] = useState();
    const [orderDetail, setOrderDetail] = useState();
    const [orderVariety, setOrderVariety] = useState();
    const [selectedAccount, setSelectedAccount] = useState('');
    const [trades, setTrades] = useState([]);
    const [challengeProgressBar, setChallengeProgressBar] = useState({
        status: '',
        value: 0
    });
    const [summary, setSummary] = useState({
        // "dailyProfits": {
        //     "2024-12-03": -23.379999999999995,
        //     "2024-12-04": 50.97,
        //     "2024-12-05": -6.320000000000001,
        //     "2024-12-06": 8.46,
        //     "2024-12-09": -48.71999999999999,
        //     "2024-12-10": 25.04,
        //     "2024-12-11": 21.52,
        //     "2024-12-13": 38.760000000000005,
        //     "2024-12-17": -86.99,
        //     "2024-12-24": -86.32000000000001,
        //     "2025-01-13": 75,
        //     "2025-01-16": -51.25
        // },
        // "dailyDrawDown": {
        //     "2024-12-03": -23.81,
        //     "2024-12-04": -20.95,
        //     "2024-12-05": -7.040000000000001,
        //     "2024-12-06": -8.769999999999998,
        //     "2024-12-09": -48.71999999999999,
        //     "2024-12-10": -26.29,
        //     "2024-12-11": 0,
        //     "2024-12-13": -42.58,
        //     "2024-12-17": -86.99,
        //     "2024-12-24": -86.32000000000001,
        //     "2025-01-13": -44.58,
        //     "2025-01-16": -51.25
        // },
        // "dailyDrawDownPercent": {
        //     "2024-12-03": -0.4762,
        //     "2024-12-04": -0.42096844846502246,
        //     "2024-12-05": -0.14002732919748828,
        //     "2024-12-06": -0.17465700908335932,
        //     "2024-12-09": -0.9686404638022317,
        //     "2024-12-10": -0.5278046018779323,
        //     "2024-12-11": 0,
        //     "2024-12-13": -0.8469300278265642,
        //     "2024-12-17": -1.7170219863293545,
        //     "2024-12-24": -1.733563082657541,
        //     "2025-01-13": -0.9110937621346326,
        //     "2025-01-16": -1.0315981014569184
        // },
        // "starterCapitalOfTheDay": {
        //     "2024-12-03": 5000,
        //     "2024-12-04": 4976.62,
        //     "2024-12-05": 5027.59,
        //     "2024-12-06": 5021.27,
        //     "2024-12-09": 5029.7300000000005,
        //     "2024-12-10": 4981.01,
        //     "2024-12-11": 5006.05,
        //     "2024-12-13": 5027.570000000001,
        //     "2024-12-17": 5066.330000000001,
        //     "2024-12-24": 4979.34,
        //     "2025-01-13": 4893.02,
        //     "2025-01-16": 4968.02
        // },
        // "allowedDrawdownForFivePercentDaily": {
        //     "2024-12-03": 250,
        //     "2024-12-04": 248.83100000000002,
        //     "2024-12-05": 251.3795,
        //     "2024-12-06": 251.06350000000003,
        //     "2024-12-09": 251.48650000000004,
        //     "2024-12-10": 249.05050000000003,
        //     "2024-12-11": 250.3025,
        //     "2024-12-13": 251.37850000000003,
        //     "2024-12-17": 253.31650000000005,
        //     "2024-12-24": 248.967,
        //     "2025-01-13": 244.65100000000004,
        //     "2025-01-16": 248.40100000000004
        // },
        // "LowestDailyDrawdown": {
        //     "lowestDailyDrawdown": -86.32000000000001,
        //     "lowestDailyDrawdownPercent": -1.733563082657541
        // },
        // "targetProfitPercent": 0,
        // "totalDrawdown": {
        //     "totalDrawdown": -151.56,
        //     "totalDrawdownPercent": -3.0312
        // },
        // "AllowedTodayDrawdown": {
        //     "todayDrawDown": 0,
        //     "todayDrawDownPercent": 0,
        //     "allowedDailyAmount": 248.40100000000004
        // },
        // "updatedAt": {
        //     "$date": "2025-01-18T17:20:02.664Z"
        // }
    });
    const [challengeInformation, setChallengeInformation] = useState({
        numberOfTradingDays: 0,
        numberOfProfitableTradingDays: 0,
        lowestDailyDrawdown: 0,
        lowestDailyDrawdown2: 0,
        lowestTodayDrawdown: 0,
        maxConsecutiveLosses: 0,
        maxConsecutiveLossSum: 0,
        totalTrades: 0,
        profitTrades: 0,
        lossesTrades: 0,
        averageProfitInProfitableTrades: 0,
        averageLossInLossTrades: 0
    });
    const [accountInformation, stAccountInformation] = useState(
        {
            "accountCreationDate": "",
            "ChallengeCreationDate": "",
            "initialCapital": 0,
            "equity": 0,
            "platform": "-",
            "server": "-",
            "broker": "-",
            "leverage": 0
        }
    );

    const [balanceChart, setBalanceChart] = useState({
        labels: ['12', '13', '14', '15', '16', '17', '18'],
        datasets: [
            {
                label: '',
                data: [3020, 3035, 3060, 3067, 3099, 3107, 3130, 3190],
                fill: false,
                backgroundColor: '#4F9D81',
                borderColor: '#4F9D81',

            }
        ],
    });


    const [isModalOpen, setIsModalOpen] = useState(false);


    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    async function getOrderDetail() {
        try {
            setLoadingOrderDetails(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/review/${orderId}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                console.log('setOrderDetail', orderDetail)
                setOrderDetail(res.data.data)
                setMainUser(res.data.data.mainUser)
                setOrderVariety(res.data.data.variety)
                setSummary(res.data.data.summary)
                setLoadingOrderDetails(false)
            }
        } catch (e) {
            ErrorToaster(e, t)
            setLoadingOrderDetails(false)
        }
    }

    useEffect(() => {
        if (id && review_id) {
            setSelectedAccount(id)
            getAccountsByReview();
        } else {
            getAccounts();
        }
    }, []);

    useEffect(() => {
        console.log('-------{orderId}--------', orderId)
        if (orderId)
            getOrderDetail()
    }, [orderId]);


    useEffect(() => {
        if (accountInformation.equity > 0) {
            setChallengeProgressBar(calculateChallengePercent())
        }
    }, [accountInformation]);


    function calculateChallengeInformation() {
        function calculateNumberOfTradingDays() {
            // Initialize a Set to store unique trading days
            const tradingDaysSet = new Set();
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));


            // Iterate through trades and extract unique trading days
            sortedTrades?.forEach(item => {
                const date = new Date(item.exitTime).toISOString().split('T')[0]; // Extract date part (YYYY-MM-DD)
                tradingDaysSet.add(date); // Add date to Set (automatically handles duplicates)
            });

            // Convert the Set to an Array of unique trading days if needed
            const uniqueTradingDays = Array.from(tradingDaysSet);

            // Count the number of unique trading days
            const numberOfTradingDays = tradingDaysSet.size;

            // console.log('Unique Trading Days:', uniqueTradingDays);
            // console.log('Number of Trading Days:', numberOfTradingDays);
            return numberOfTradingDays
        }

        function calculateNumberOfProfitableTradingDay() {
            // Initialize an object to store the profit of each day
            const dailyProfits = {};
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            // Step 1: Group trades by day and calculate the profit of each day
            sortedTrades?.forEach(item => {
                const date = item?.entryTime ? new Date(item.entryTime)?.toISOString().split('T')[0] : null;

                if (!date) {
                    // console.warn('Invalid entryTime detected in trade:', item);
                    return; // Skip this trade
                }
                // If the date is not in dailyProfits, initialize it with the pnl of the first trade
                if (!dailyProfits[date]) {
                    dailyProfits[date] = item.pnl;
                } else {
                    // Otherwise, add the pnl to the existing value for that day
                    dailyProfits[date] += item.pnl;
                }
            });

            // Step 2: Count the number of days with a positive total profit
            const positiveProfitDays = Object.values(dailyProfits).filter(profit => profit > 0).length;

            // Step 3: Log the results
            // console.log('Daily Profits:', dailyProfits);
            // console.log('Number of Positive Profit Days:', positiveProfitDays);
            return positiveProfitDays
        }

        function calculateLowestDailyDrawdown() {
            // Initialize an object to store the profit of each day
            const dailyProfits = {};
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            // Step 1: Group trades by day and calculate the profit of each day
            sortedTrades?.forEach(item => {
                const date = item?.entryTime ? new Date(item.entryTime)?.toISOString().split('T')[0] : null;

                if (!date) {
                    // console.warn('Invalid entryTime detected in trade:', item);
                    return; // Skip this trade
                }
                // If the date is not in dailyProfits, initialize it with the pnl of the first trade
                if (!dailyProfits[date]) {
                    dailyProfits[date] = item.pnl + item?.entryCommission + item?.exitCommission;
                } else {
                    // Otherwise, add the pnl to the existing value for that day
                    dailyProfits[date] += item.pnl + item?.entryCommission + item?.exitCommission;
                }
            });

            // Step 2: Find the lowest daily profit
            const lowestDailyDrawdown = Math.min(...Object.values(dailyProfits));

            // Step 3: Log or return the lowest daily profit
            // console.log('Lowest Daily Profit:', lowestDailyDrawdown);

            return lowestDailyDrawdown;
        }

        function calculateLowestDailyDrawdown2(initialCapital) {
            // Initialize an object to store the profit of each day
            let remainingCapital = initialCapital;
            let remainingCapitalEndOfTheDay = initialCapital;
            const dailyProfits = {};
            const dailyProfitsPercent = {};
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            // Step 1: Group trades by day and calculate the profit of each day
            sortedTrades?.forEach((item, index) => {
                const date = item?.entryTime ? new Date(item.entryTime)?.toISOString().split('T')[0] : null;

                if (!date) {
                    // console.warn('Invalid entryTime detected in trade:', item);
                    return; // Skip this trade
                }

                if (!dailyProfits[date]) {
                    remainingCapitalEndOfTheDay = remainingCapital;
                }
                const profit = item.pnl + (item?.commission || 0);
                const percent = profit * 100 / remainingCapitalEndOfTheDay;
                // console.log('--------', "initialCapital", initialCapital, index, 'remainingCapital', remainingCapital, 'remainingCapitalEndOfTheDay', remainingCapitalEndOfTheDay, 'profit', profit,'percent',  percent)
                // If the date is not in dailyProfits, initialize it with the pnl of the first trade
                if (!dailyProfits[date]) {
                    dailyProfits[date] = profit;
                    dailyProfitsPercent[date] = percent;
                } else {
                    // Otherwise, add the pnl to the existing value for that day
                    dailyProfits[date] += profit;
                    dailyProfitsPercent[date] += percent;
                }

                remainingCapital = remainingCapital + profit;
            });

            console.log('dailyProfits',dailyProfits)
            // Step 2: Find the lowest daily profit
            const lowestDailyDrawdown = Object.values(dailyProfits).length > 0 ? Math.min(...Object.values(dailyProfits)) : 0;
            const lowestDailyDrawdownPercent = Object.values(dailyProfitsPercent).length > 0 ? Math.min(...Object.values(dailyProfitsPercent)) : 0;

            // Step 3: Log or return the lowest daily profit
            // console.log('Lowest Daily Profit2:',
            //     'dailyProfits', dailyProfits,
            //     'dailyProfitsPercent', dailyProfitsPercent,
            //     'lowestDailyDrawdownPercent', lowestDailyDrawdownPercent,
            //     'lowestDailyDrawdown', lowestDailyDrawdown
            // );

            return {lowestDailyDrawdown, lowestDailyDrawdownPercent};
        }


        function calculateTodaysDrawdown2(initialCapital) {
            // Initialize an object to store the profit of each day
            let remainingCapital = initialCapital;
            let remainingCapitalEndOfTheDay = initialCapital;
            const dailyProfits = {};
            const todayDrawDown = {};
            const todayDrawDownPercent = {};
            const dailyProfitsPercent = {};
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            // Step 1: Group trades by day and calculate the profit of each day
            sortedTrades?.forEach((item, index) => {

                const date = item?.exitTime ? new Date(item.exitTime)?.toISOString().split('T')[0] : null;


                if (!date) {
                    // console.warn('Invalid entryTime detected in trade:', item);
                    return; // Skip this trade
                }

                if (!dailyProfits[date]) {
                    remainingCapitalEndOfTheDay = remainingCapital;
                }
                const profit = item.pnl + (item?.commission || 0);
                // console.log('--------', "initialCapital", initialCapital, index, 'remainingCapital', remainingCapital, 'remainingCapitalEndOfTheDay', remainingCapitalEndOfTheDay, 'profit', profit,'percent',  percent)
                // If the date is not in dailyProfits, initialize it with the pnl of the first trade
                if (!dailyProfits[date]) {
                    dailyProfits[date] = profit;
                    todayDrawDown[date] = profit < 0 ? profit : 0;
                    todayDrawDownPercent[date] = todayDrawDown[date] * 100 / remainingCapitalEndOfTheDay;

                } else {
                    // Otherwise, add the pnl to the existing value for that day
                    dailyProfits[date] += profit;
                    todayDrawDown[date] = dailyProfits[date] < todayDrawDown[date] ? dailyProfits[date] : todayDrawDown[date];
                    todayDrawDownPercent[date] = todayDrawDown[date] * 100 / remainingCapitalEndOfTheDay;

                }

                remainingCapital = remainingCapital + profit;
            });


            let today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
            let todayTrades = trades?.filter(item => new Date(item.exitTime).toISOString().split('T')[0] === today).slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            let result = {
                lowestDailyDrawdown: 0,
                lowestDailyDrawdownPercent: 0,
                allowedDailyAmount: remainingCapitalEndOfTheDay * 0.05
            }

            Object.keys(dailyProfits).find((key, keyIndex) => {
                if (key === today) {
                    result = {
                        ...result,
                        lowestDailyDrawdown: todayDrawDown[key],
                        lowestDailyDrawdownPercent: todayDrawDownPercent[key],
                    }
                }
            })

            // Step 3: Log or return the lowest daily profit
            // console.log('Lowest today Profit2:',result, dailyProfits, dailyProfitsPercent);

            return result;
        }


        function calculateTodaysDrawdown(initialCapital) {
            // Initialize variables
            let today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
            let todayTrades = trades?.filter(item => new Date(item.exitTime).toISOString().split('T')[0] === today);

            let remainingCapital = initialCapital;
            let remainingCapitalEndOfTheDay = initialCapital;
            const dailyProfits = {};
            const dailyProfitsPercent = {};

            let cumulativeProfit = 0;
            let peakProfit = 0;
            let drawdown = 0;

            // Process trades for today
            todayTrades?.forEach(item => {
                cumulativeProfit += item.pnl; // Update cumulative profit/loss
                peakProfit = Math.max(peakProfit, cumulativeProfit); // Update peak profit/loss
                drawdown = Math.min(drawdown, cumulativeProfit - peakProfit); // Update drawdown
            });

            // Log or return the drawdown for today
            // console.log('Today\'s Drawdown:', drawdown);
            return drawdown;
        }

        function countMaxConsecutiveLosses() {
            // Step 1: Sort the trades by exitTime
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            let maxConsecutiveLosses = 0;
            let currentLossStreak = 0;

            // Step 2: Iterate through the sorted trades
            sortedTrades.forEach((item, index) => {
                if (item.pnl < 0) {
                    // If the trade is a loss, increment the current loss streak
                    currentLossStreak++;
                    // Update the maximum consecutive loss streak if the current one is larger
                    if (currentLossStreak > maxConsecutiveLosses) {
                        maxConsecutiveLosses = currentLossStreak;
                    }
                } else {
                    // If the trade is profitable, reset the current loss streak
                    currentLossStreak = 0;
                }
            });

            return maxConsecutiveLosses;
        }

        function calculateMaxConsecutiveLossSum() {
            // Step 1: Sort the trades by exitTime
            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            let maxConsecutiveLossSum = 0;
            let currentLossSum = 0;

            // Step 2: Iterate through the sorted trades
            sortedTrades.forEach(item => {
                currentLossSum += item.pnl + item?.entryCommission + item?.exitCommission;

                // Update the maximum consecutive loss sum if the current one is larger (more negative)
                if (currentLossSum < maxConsecutiveLossSum) {
                    maxConsecutiveLossSum = currentLossSum;
                }
            });

            return maxConsecutiveLossSum;
        }

        function calculateTotalTrades() {
            return trades.length;
        }

        function calculateNumberOfProfitableTrades() {
            return trades.filter(item => item.pnl > 0).length;
        }

        function calculateNumberOfLoosesTrades() {
            return trades.filter(item => item.pnl < 0).length;
        }

        function calculateAverageProfitOfProfitableTrades() {
            let sum = 0;
            let count = trades.filter(item => item.pnl > 0).map(item => {
                return sum += item.pnl
            }).length;

            return sum / count;
        }

        function calculateAverageLossOfLossesTrades() {
            let sum = 0;
            let count = trades.filter(item => item.pnl < 0).map(item => {
                return sum += item.pnl
            }).length;

            return sum / count;
        }

        const numberOfTradingDays = calculateNumberOfTradingDays();
        const numberOfProfitableTradingDays = calculateNumberOfProfitableTradingDay();
        const lowestDailyDrawdown = calculateLowestDailyDrawdown();
        const lowestDailyDrawdown2 = calculateLowestDailyDrawdown2(accountInformation.initialCapital);
        const lowestTodayDrawdown = calculateTodaysDrawdown2(accountInformation.initialCapital);
        const maxConsecutiveLosses = countMaxConsecutiveLosses();
        const maxConsecutiveLossSum = calculateMaxConsecutiveLossSum();
        const totalTrades = calculateTotalTrades();
        const profitTrades = calculateNumberOfProfitableTrades();
        const lossesTrades = calculateNumberOfLoosesTrades();
        const averageProfitInProfitableTrades = calculateAverageProfitOfProfitableTrades();
        const averageLossInLossTrades = calculateAverageLossOfLossesTrades();


        setChallengeInformation({
            numberOfTradingDays,
            numberOfProfitableTradingDays,
            lowestDailyDrawdown,
            lowestDailyDrawdown2,
            lowestTodayDrawdown,
            maxConsecutiveLosses,
            maxConsecutiveLossSum,
            totalTrades,
            profitTrades,
            lossesTrades,
            averageProfitInProfitableTrades,
            averageLossInLossTrades
        })

    }

    useEffect(() => {
        console.log('selectedAccount', selectedAccount)
        if (selectedAccount) {
            const initialCapital = getAccountInformation(selectedAccount)
            getTrades(selectedAccount);
        }
    }, [selectedAccount]);

    useEffect(() => {
        // console.log('trades', trades)
        if (trades && accountInformation.initialCapital > 0) {
            const tradeItems = trades?.filter(item => item.entryType === "DEAL_ENTRY_OUT");
            let chartDate = [];

            tradeItems?.map((item, index) => {
                chartDate.push(index > 0 ? (item.profit + chartDate[index - 1]) : item.profit)
            })
            setBalanceChart({
                labels: tradeItems?.map(item => {
                    return getFormattedDateForChart(item.time)
                }),
                datasets: [
                    {
                        label: '',
                        data: chartDate,
                        fill: false,
                        backgroundColor: '#4F9D81',
                        borderColor: '#4F9D81',

                    }
                ],
            })
            calculateChallengeInformation();
        }
    }, [trades, accountInformation]);

    function getFormattedDateForChart(dateString) {

// Convert the string to a Date object
        const date = new Date(dateString);

// Extract the components
        const year = date.getFullYear().toString().slice(2); // Get last two digits of the year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const day = date.getDate().toString().padStart(2, '0');

// Format the date as DD/MM/YY
        const formattedDate = `${year}/${month}/${day}/`;

        return formattedDate;
    }

    async function getAccounts() {
        try {
            setLoadingAccounts(true)


            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/review/accounts/mine`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('mine Accounts -_-_-_-_-_-_-_-_-', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {

                setAccounts(res.data.data)
                setLoadingAccounts(false)
            }

        } catch (e) {
            ErrorToaster(e, t)
            setLoadingAccounts(false)
        }

    }

    async function getAccountsByReview() {
        try {

            setLoadingAccounts(true)


            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/review/review-accounts/${review_id}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })
            if (res.data.statusCode === 200 || !res.data.statusCode) {
                // console.log('data', res.data.data)
                setAccounts(res.data.data)
                setOrderId(res.data.data[0].orderId)
                setLoadingAccounts(false)
            }


        } catch (e) {
            ErrorToaster(e, t)
            setLoadingAccounts(false)
        }

    }

    async function getTrades(accountMetaapiId) {
        try {
            // console.log('accountMetaapiId', accountMetaapiId)
            const status = accounts?.find(i => i.account?.metaapi_id === accountMetaapiId)?.status;
            const _metaapi_server = accounts?.find(i => i.account?.metaapi_id === accountMetaapiId)?.account?.metaapi_server;
            console.log('metaapi_server', metaapi_server, accounts)
            if ((status === 'active' && accountMetaapiId) || id) {
                setLoadingOrders(true)
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/history-orders/${accountMetaapiId}/${_metaapi_server ? _metaapi_server : metaapi_server}/1970-01-01T00:00:00Z/${new Date()}`, {
                    headers: {authorization: `Bearer ${auth.token}`}
                })

                if (res.data.statusCode === 200 || !res.data.statusCode) {
                    // console.log('trades', res.data.data)
                    setTrades(res.data.data.filter(item => item.exitTime))
                    setLoadingOrders(false)
                }

            } else {
                throw new Error('اکانت غیر فعال شده است')
            }
        } catch (e) {
            // console.log('history-orders', e)
            const errorMessage = e.response.data.message;
            const accountIdMatch = errorMessage.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/);
            const accountId = accountIdMatch ? accountIdMatch[0] : '';

            // console.log('accountId',accountId)
            if (accountId) {
                //NO ACTION
                // ErrorToasterDirectString(t('accountNotConnected', {accountId}))
            } else
                ErrorToaster(e, t)
            setLoadingOrders(false)
        }
    }

    async function getAccountInformation(accountId) {
        try {
            const status = accounts?.find(i => i.account?.metaapi_id === accountId)?.status;
            const _metaapi_server = accounts?.find(i => i.account?.metaapi_id === accountId)?.account?.metaapi_server;
            if ((status === 'active' && accountId) || id) {
                setIsLoading(true)
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/account-initial-capital/${accountId}/${_metaapi_server ? _metaapi_server : metaapi_server}`, {
                    headers: {authorization: `Bearer ${auth.token}`}
                })

                if (res.data.statusCode === 200 || !res.data.statusCode) {
                    console.log('initialCapital', res.data.data)
                    stAccountInformation(res.data.data)
                    setIsLoading(false)
                }

                return res.data.data.initialCapital

            }
        } catch (e) {
            //NO ACTION
            // ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    function Passed() {
        return (
            <div style={{gap: "10px"}}>
                <IoMdCheckmarkCircle color={"#4F9D81"} size={22}/>
                فعال
            </div>
        )
    }

    function Rejected() {
        return (
            <div style={{gap: "10px"}}>
                <IoCloseSharp color={"#FF0000"} size={22}/>
                رد شده
            </div>
        )
    }

    function Blocked() {
        return (
            <div className="d-flex flex-row" style={{gap: "10px"}}>
                <IoCloseSharp color={"#FF0000"} size={22}/>
                بلاک شده
            </div>
        )
    }
    function findTargetPercentAmount() {


        //one_stage
        if(orderDetail?.level === 1 && orderVariety.slug === 'real_direct')
            return -1



        //one_stage
        if(orderDetail?.level === 1 && orderVariety.slug === 'one_stage')
            return 10

        //one_stage
        if(orderDetail?.level === 2 && orderVariety.slug === 'one_stage')
            return -1


        //one_stage
        if(orderDetail?.level === 1 && orderVariety.slug === 'tow_stage')
            return 8

        if(orderDetail?.level === 2 && orderVariety.slug === 'tow_stage')
            return 4

        if(orderDetail?.level === 3 && orderVariety.slug === 'tow_stage')
            return -1


        //three_stage
        if(orderDetail?.level === 1 && orderVariety.slug === 'three_stage')
            return 6

        if(orderDetail?.level === 2 && orderVariety.slug === 'three_stage')
            return 4

        if(orderDetail?.level === 3 && orderVariety.slug === 'three_stage')
            return 2

        if(orderDetail?.level === 4 && orderVariety.slug === 'three_stage')
            return -1

        return 0
    }

    function AccountSummary() {
        function LineChartComponent() {
            return (
                <GrowthLineChartComponent trades={trades}/>
            );
        }

        function ChallengeTable() {
            const formattedDatetime = accountInformation?.ChallengeCreationDate ? moment(accountInformation?.ChallengeCreationDate) : '-';

            const data = [
                {
                    key: "وضعیت",
                    value: accountInformation.result === 'active' ? <Passed/> : <Rejected/>
                },
                {key: "زمان شروع", value: ConvertGregorianToJalali(formattedDatetime, false)},
                {key: "زمان پایان", value: '-'},
                {key: "بالانس", value: `$${accountInformation.initialCapital}`},
                {key: "پلتفرم", value: accountInformation.platform},
                {key: "تامین کنده", value: 'مسترپراب فاند'},
            ];

            return (
                <table border="1" cellPadding="10" className="mb-2">
                    <thead>
                    <tr>
                        <th>وضعیت چالش</th>
                    </tr>
                    </thead>
                    <tbody  className={"first-page"}>
                    <tr>
                        {data.map((item, index) => (
                            <tr key={item.index}>
                                <td>{item.key}</td>
                                <td>{item.value}</td>
                            </tr>
                        ))}
                    </tr>
                    </tbody>
                </table>
            );
        };

        function ResultsTable() {

            const data = [
                /*             {
                                 goal: "حداقل  ۱۰ روز معاملاتی",
                                 result: `${challengeInformation.numberOfTradingDays} روز`,
                                 status: challengeInformation.numberOfTradingDays > 10 ? <Passed/> : <Rejected/>
                             },
                             {
                                 goal: "۵۰٪ روزهای معاملاتی مثبت",
                                 result: `${challengeInformation.numberOfProfitableTradingDays} روز `,
                                 status: challengeInformation.numberOfProfitableTradingDays * 100 / challengeInformation.numberOfTradingDays > 50 ?
                                     <Passed/> : <Rejected/>
                             },*/
                {
                    goal: `حداکثر دراودان مجاز امروز (5%)${summary?.AllowedTodayDrawdown?.allowedDailyAmount?.toFixed(2) || 0.0}$`,
                    result: `$${summary?.AllowedTodayDrawdown?.todayDrawDown?.toFixed(2) || 0.0} (${summary?.AllowedTodayDrawdown?.todayDrawDownPercent?.toFixed(2) || 0.0}%)`,
                    status: summary?.AllowedTodayDrawdown?.allowedDailyAmount < summary?.AllowedTodayDrawdown?.todayDrawDown ?
                            <Rejected/> : ((summary?.AllowedTodayDrawdown?.todayDrawDownPercent) < -5 ?
                            <Rejected/>: <Passed/>)
                },

                //Old
                // {
                //     goal: `حداکثر ضرر روزانه (5%)${accountInformation.initialCapital * 0.05}$`,
                //     result: `$${challengeInformation.lowestDailyDrawdown.toFixed(2)}  (${(challengeInformation.lowestDailyDrawdown * 100 / accountInformation.initialCapital).toFixed(2)}%)`,
                //     status: (challengeInformation.lowestDailyDrawdown * 100 / accountInformation.initialCapital).toFixed(2) > -5 ?
                //         <Passed/> : <Rejected/>
                // },

                //New
                {
                    goal: `بیشترین دراودان روزانه دیده شده (5%)`,
                    result: `$${summary?.LowestDailyDrawdown?.lowestDailyDrawdown?.toFixed(2) || 0.0} (${summary?.LowestDailyDrawdown?.lowestDailyDrawdownPercent?.toFixed(2) || 0.0}%)`,
                    status: (summary?.LowestDailyDrawdown?.lowestDailyDrawdownPercent) * -1  < -5 ?
                        <Rejected/> : <Passed/>
                },
                {
                    goal: `دراودان  کل (12%)${accountInformation.initialCapital * 0.12}$`,
                    result: `$${summary?.totalDrawdown?.totalDrawdown?.toFixed(2) || 0.0}  (${summary?.totalDrawdown?.totalDrawdownPercent?.toFixed(2) || 0.0}%)`,
                    status: (summary?.totalDrawdown?.totalDrawdownPercent) * -1  < -12 ?
                        <Rejected/> : <Passed/>
                },
                {
                    goal: findTargetPercentAmount() === -1 ? `بدون تارگت` : `تارگت مرحله ${orderDetail?.level} (${findTargetPercentAmount()}%)`,
                    result: `(${summary?.targetProfitPercent?.toFixed(2) || 0.0}%)`,
                    status:  findTargetPercentAmount() === -1  ?  '-' : summary?.targetProfitPercent < findTargetPercentAmount() ?
                        <Rejected/> : <Passed/>
                },
                /*                {
                                    goal: "حداکثر ۱۰ ضرر  پشت سر هم",
                                    result: challengeInformation.maxConsecutiveLosses,
                                    status: challengeInformation.maxConsecutiveLosses < 10 ? <Passed/> : <Rejected/>
                                },*/
            ];

            return (
                <table border="1" cellPadding="10">
                    <thead>
                    <tr>
                        <th>اهداف چالش</th>
                        <th>نتیجه شما</th>
                        <th>نتیجه</th>
                    </tr>
                    </thead>
                    <tbody   className={"first-page"}>
                    {data.map((item, index) => (
                        <tr key={item.index}>
                            <td>{item.goal}</td>
                            <td>{item.result}</td>
                            <td>{item.status}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            );
        };

        function AccountInfoTable() {
            const data = [
                {key: "ایکوئیتی", value: `$${accountInformation.equity}`},
                {key: "مقدار Lot", value: '-'},
                {key: "تعداد معاملات", value: challengeInformation.totalTrades},
                {key: "نوع چالش", value: orderVariety?.name},
                {key: "مرحله فعلی", value: orderDetail?.level},
                {key: "تعداد معاملات سود", value: challengeInformation.profitTrades},
                {key: "تعداد معاملات ضرر", value: challengeInformation.lossesTrades},
                {key: "میانگین سود", value: `$${challengeInformation?.averageProfitInProfitableTrades?.toFixed(2) || 0.0}`},
                {key: "میانگین ضرر", value: `$${challengeInformation?.averageLossInLossTrades?.toFixed(2) || 0.0}`},
                {key: "میانگین R/R", value: '-'},
            ];

            return (
                <table border="1" cellPadding="10" className="mb-2">
                    <thead>
                    <tr>
                        <th>اطالاعات حساب</th>
                    </tr>
                    </thead>
                    <tbody   className={"first-page"}>
                    <tr>
                        {data.map((item, index) => (
                            <tr key={item.index}>
                                <td>{item.key}</td>
                                <td>{item.value}</td>
                            </tr>
                        ))}
                    </tr>
                    </tbody>
                </table>
            );
        };

        function ConnectionStatus() {
            const [isOrderInfoLoading, setIsOrderInfoLoading] = useState(false);

            const activeAccount = orderDetail?.accounts.find(i => i?.metaapi_id === id);
            console.log('activeaccounts-----', activeAccount)

            async function deployAccount(metaapi_id, metaapi_server) {
                try {
                    setIsOrderInfoLoading(true)
                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/redeploy-trading-account/${metaapi_id}/${metaapi_server}`, {
                        headers: {authorization: `Bearer ${auth.token}`}
                    })

                    if (res.data.statusCode === 200 || !res.data.statusCode) {
                        SuccessToaster({message: 'عملیات deploy با موفقیت انجام گرفت'}, t)
                        //reload page again
                        getOrderDetail()
                    }

                    setIsOrderInfoLoading(false)
                } catch (e) {
                    ErrorToaster(e, t)
                    setIsOrderInfoLoading(false)
                }
            }

            async function undeployAccount(metaapi_id, metaapi_server) {
                try {
                    setIsOrderInfoLoading(true)
                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/undeploy-trading-account/${metaapi_id}/${metaapi_server}`, {
                        headers: {authorization: `Bearer ${auth.token}`}
                    })

                    if (res.data.statusCode === 200 || !res.data.statusCode) {
                        SuccessToaster({message: 'عملیات undeploy با موفقیت انجام گرفت'}, t)
                        getOrderDetail()
                    }

                    setIsOrderInfoLoading(false)
                } catch (e) {
                    ErrorToaster(e, t)
                    setIsOrderInfoLoading(false)
                }
            }

            function ChangeDeploymentStatusComponent() {
                return (
                    <div
                        className={`account-detail-value-analytics-page ${activeAccount?.deployment === "DEPLOYED" ? 'green-color' : 'red-color'}`}>
                        {activeAccount?.deployment === "DEPLOYED" || activeAccount?.deployment === "UNDEPLOYED" ?
                            <button disabled={activeAccount?.disabled || isOrderInfoLoading || loadingOrderDetails}
                                    style={{maxWidth: "90px"}}
                                    className={`btn small-button ${activeAccount?.deployment === "DEPLOYED" ? 'red-bg-color' : (activeAccount?.deployment === "UNDEPLOYED" ? 'green-bg-color' : '')} analycis-btn`}
                                    type="button"
                                    onClick={async () => {
                                        if (activeAccount?.deployment === "DEPLOYED")
                                            await undeployAccount(activeAccount?.metaapi_id, activeAccount?.metaapi_server);
                                        if (activeAccount?.deployment === "UNDEPLOYED")
                                            await deployAccount(activeAccount?.metaapi_id, activeAccount?.metaapi_server);
                                    }}>
                                {activeAccount?.deployment === "DEPLOYED" ? 'Undeploy' : (activeAccount?.deployment === "UNDEPLOYED" ? 'Deploy' : '')}
                            </button> :
                            ''
                        }
                    </div>
                )
            }


            const data = [
                {key: "نام و نام خانوادگی", value: `${mainUser?.fullName || '-'}`},
                {key: "ایمیل", value: `${mainUser?.email || '-'}`},
                {key: "MetaAPI ID", value: `$${activeAccount?.metaapi_id}`},
                {key: "Deployment",
                    value: <div
                        className={`account-detail-value-analytics-page ${activeAccount?.deployment === "DEPLOYED" ? 'green-color' : 'red-color'}`}>{activeAccount?.deployment || "NONE"} </div>
                },
                {key: "Connection",
                    value: <div
                        className={`account-detail-value-analytics-page ${activeAccount?.connectionStatus === "CONNECTED" ? 'green-color' : 'red-color'}`}>{activeAccount?.connectionStatus || "NONE"}</div>
                },
                {key: "State", value: <ChangeDeploymentStatusComponent/>},
            ];

            return (
                <table border="1" cellPadding="10" className="mb-2">
                    <thead>
                    <tr>
                        <th>وضعیت اتصال</th>
                    </tr>
                    </thead>
                    <tbody className={"first-page"}>
                    <tr>
                        {data.map((item, index) => (
                            <tr key={item.index}>
                                <td>{item.key}</td>
                                <td>{item.value}</td>
                            </tr>
                        ))}
                    </tr>
                    </tbody>
                </table>
            );
        };

        return (
            <div>
                <div className="d-flex analytics-container">
                    <div className="analytics-right d-flex flex-column ms-3">
                        <LineChartComponent/>
                        <ResultsTable/>
                    </div>
                    <div className="analytics-left  d-flex flex-column  mb-4 ">
                        <AccountInfoTable/>
                        <ChallengeTable/>
                        {
                            profileState.roles.includes('admin') ?
                                <ConnectionStatus/> : ''
                        }
                    </div>
                </div>
            </div>
        )
    }

    function TradeHistory() {
        function TradeHistory() {

            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            return (
                <table border="1" cellPadding="10" className="mb-2 w-100">
                    <thead>
                    <tr>
                        <th>جفت ارز</th>
                        <th>شناسه</th>
                        <th className={'just-web'}>تاریخ</th>
                        <th>نوع</th>
                        <th>حجم(Lot)</th>
                        {/*<th>قیمت</th>*/}
                        <th>کمیسیون</th>
                        <th className="pnl-col">سود/ضرر</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sortedTrades?.slice().reverse().map((item, index) => (
                        <tr key={item.positionId}>
                            <td>{item.symbol}</td>
                            <td>{item.positionId}</td>
                            <td className={'just-web'}>{item.exitTime}</td>
                            <td className={item.type === "DEAL_TYPE_SELL" ? "table-text-red" : "table-text-green"}>{item.type === "DEAL_TYPE_SELL" ? 'Sell' : 'Buy'}</td>
                            <td>{item.volume} Lot</td>
                            {/*<td>{
                                new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(item.openPrice)
                            }</td>*/}
                            <td>{
                                new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(item.commission)
                            }</td>
                            <td className={item.pnl < 0 ? "table-text-red" : "table-text-green"}>{
                                new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(item.pnl)
                            }</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            );
        };


        function TradeHistoryMobile() {

            const sortedTrades = trades?.slice().sort((a, b) => new Date(a.exitTime) - new Date(b.exitTime));

            function TradeCardItem({pair, type, volume, pnl, commission, exitAt}) {
                return (
                    <div className={'trade-history-mobile-container'}>
                        <div className="d-flex flex-row trade-history-mobile-item">
                            <h3>{pair}</h3>
                            <div>
                                <span className={type === "DEAL_TYPE_SELL" ? "table-text-red" : "table-text-green"}>
                                    {type === "DEAL_TYPE_SELL" ? 'Sell' : 'Buy'}
                                </span>
                            </div>
                        </div>
                        <Divider/>
                        <div className="d-flex flex-row trade-history-mobile-pnl"  style={{marginBottom: "30px"}}>
                            <h5>{volume} LOT</h5>
                            <h3  className={pnl < 0  ? "table-text-red" : "table-text-green"}>
                                {new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(pnl)}
                            </h3>
                        </div>
                        <div className="d-flex flex-row trade-history-mobile-item">
                            <div className={'cmm'}>{commission}</div>
                            <div>کمیسیون</div>
                        </div>
                        <div className="d-flex flex-row trade-history-mobile-item">
                            <div>{exitAt}</div>
                            <div>تاریخ</div>
                        </div>
                    </div>
                )
            }

            return (
                <>
                    {sortedTrades?.slice().reverse().map((item, index) => (
                        <TradeCardItem
                            pair={item.symbol}
                            type={item.type}
                            volume={item.volume}
                            exitAt={item.exitTime}
                            commission={
                                new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(item.commission)
                            }
                            pnl={item.pnl}
                        />
                    ))}
                </>
            );
        };

        return (
            <div>
                <div className="d-flex flex-row ">
                    <span className={'trade-history-mobile-activate'}>
                        <TradeHistoryMobile/>
                    </span>
                    <span className={'trade-history-web-activate'}>
                        <TradeHistory/>
                    </span>
                </div>
            </div>
        )
    }

    function VisualizationAnalytics() {

        return (
            <div>
                <div className="d-flex flex-column ">

                    <div className="w-100">
                        <GrowthLineChartComponent trades={trades}/>
                    </div>


                    <div className="w-100">
                        <MaximumDrawdownInSingleDayLineChartComponent
                            orderDetail={orderDetail}
                            initialCapital={accountInformation.initialCapital}
                        />
                    </div>

                    <div className="w-100">
                        <NumberOfTradesCompoLineAndBarChartComponent trades={trades}/>
                    </div>

                    <div className="w-100">
                        <HighestAndLowestPnlLineChartComponent trades={trades}/>
                    </div>

                    <div className="w-100">
                        <TotalProfitAndLossVerticalLineChartComponent trades={trades}/>
                    </div>

                    <div className="multiple-chart-row">
                        <div className="w-100">
                            <SymbolsDoughnutChartComponent trades={trades}/>
                        </div>
                        <div className="w-100">
                            <LongOrShortCountDoughnutChartComponent trades={trades}/>
                        </div>
                        <div className="w-100">
                            <LongOrShortCountDoughnutChartComponent trades={trades}/>
                        </div>
                    </div>

                    <div className="multiple-chart-row">
                        <div className="w-100">
                            <TradesByHoursLineChartComponent trades={trades}/>
                        </div>
                        <div className="w-100">
                            <TradesByDayOfWeekLineChartComponent trades={trades}/>
                        </div>
                        <div className="w-100">
                            <TradesByMonthLineChartComponent trades={trades}/>
                        </div>
                    </div>


                    <div className="w-100">
                        <ProfitMFEScatterBlueChartComponent trades={trades}/>
                    </div>

                    <div className="w-100">
                        <ProfitMAEScatterRedChartComponent trades={trades}/>
                    </div>

                </div>
            </div>
        )
    }

    function calculateChallengePercent() {
        const x = accountInformation.equity * 100 / accountInformation.initialCapital;

        if (x > 100)
            return {status: 'positive', value: x - 100};
        else
            return {status: 'negative', value: 100 - x};
    }


    return (
        <React.Fragment>
            <ModalHelper
                open={isModalOpen}
                onOpen={() => setIsModalOpen(true)}
                onClose={() => setIsModalOpen(false)}
                component={modalComponent}
            />

            <div className="nk-content ">
                <div className="container-fluid">

                    <div className="profile-banner">
                        <div className="analytics-banner-status">
                            <div className='analytics-banner-container d-flex flex-column'>
                                <div className="analytics-banner-description">


                                    {
                                        id ? `
                                       آیدی حساب:  ${selectedAccount} 
                                        ` : `
                                    با توجه به حساب انتخاب شده توسط شما، روند پیشرفت چالش به صورت کامل در جداول و نمودار
                                    ها آورده شده اند. در صورت نیاز به بررسی حساب دیگر لطفا از فیلد زیر اقدام به تغییر
                                    حساب خود کنید.
                                        `
                                    }
                                </div>

                                {
                                    id ? '' :
                                        <div className="analytics-account-selection-field">
                                            <Field
                                                id={"type"}
                                                name={"type"}
                                                type={'select'}
                                                options={
                                                    accounts?.map(item => {
                                                        // console.log('item', item);
                                                        return {
                                                            value: item.account?.metaapi_id,
                                                            label: `نام کاربری: ${item.account?.username} | بروکر: ${item?.broker?.name} | بالانس: ${item.account.balance}`
                                                        }
                                                    })}
                                                value={selectedAccount}
                                                onChange={(e) => {
                                                    // console.log('e', e)
                                                    setSelectedAccount(e)
                                                    setOrderId((accounts.find(acc => acc.account?.metaapi_id === e)).orderId);
                                                }}
                                            />
                                        </div>
                                }


                                <Progress className="progress-lg w-100"
                                          barClassName={challengeProgressBar?.status === 'negative' ? 'progress-bar-red' : 'progress-bar-green'}
                                          value={Math.floor(challengeProgressBar.value)}> {Math.floor(challengeProgressBar.value)}% </Progress>
                            </div>
                        </div>
                    </div>
                    <div className="analytics-banner-status" style={{background: "#33282b", marginBottom: "20px"}}>
                        <div className='analytics-banner-container d-flex flex-column'>
                            <div className="analytics-banner-description" style={{fontSize: "15px", fontWeight: "300", color: "#cd6a7f"}}>
                                <TbAlertTriangle size={18} color={"#ff4c72e3"}/>
                                کاربر گرامی، صفحه آنالیز ممکن است با تاخیر ۵ دقیقه ای بروز شود لذا در صورت بروز مشکل در آپدیت اطلاعات حساب آن را از طریق تیکت به پشتیبانی اطلاع دهید.
                            </div>
                        </div>
                    </div>


                    {
                        (loadingAccounts || loadingOrders || isLoading) ?
                            <div className="d-flex flex-row justify-content-center align-items-center pt-5 pb-5">
                                <LoadingState/></div> :
                            <>
                                {
                                    !selectedAccount ?
                                    // ((accounts.find(i => i.account?.metaapi_id === selectedAccount)?.status !== 'active') && !id) ||
                                    // (id && accountInformation.result !== "active") ?
                                        <div>
                                            {
                                                id ?
                                                    <EmptyState
                                                        className={'analytics-empty-state'}
                                                        icon={<MdOutlineCandlestickChart size={90} color={"#5fb697"}/>}
                                                        doNotUseButton={true}
                                                        title={"این حساب از اکانت آنالیز حذف شده است"}
                                                        content={"این حساب به دلیل منقضی شدن و یا غیر فعال شدن از توسط ادمین از پنل آنالیز متا حذف شده است و اطلاعات در دسترس نمیباشد"}
                                                    /> :
                                                    <EmptyState
                                                        className={'analytics-empty-state'}
                                                        icon={<MdOutlineCandlestickChart size={90} color={"#5fb697"}/>}
                                                        doNotUseButton={true}
                                                        title={"حساب انتخاب نشده است"}
                                                        content={"لطفا از فیلد بالا یکی از حساب های خود را انتخاب کنید"}
                                                    />
                                            }
                                        </div>
                                        :
                                        <div>
                                            <div className="tab-buttons">
                                                <div className="tab-buttons-container">
                                                    <button onClick={() => handleTabClick('tab1')}
                                                            className={activeTab === 'tab1' ? 'active' : ''}>اطلاعات
                                                        حساب
                                                    </button>
                                                    <button onClick={() => handleTabClick('tab2')}
                                                            className={activeTab === 'tab2' ? 'active' : ''}>معاملات
                                                    </button>
                                                    <button onClick={() => handleTabClick('tab3')}
                                                            className={activeTab === 'tab3' ? 'active' : ''}>آنالیز
                                                        نموداری
                                                    </button>
                                                    {
                                                        profileState.roles.includes('admin') ?
                                                            <button onClick={() => handleTabClick('tab4')}
                                                                    className={activeTab === 'tab4' ? 'active' : ''}>متغیر ها
                                                            </button> : ''
                                                    }
                                                </div>
                                            </div>
                                            <div className="tab-content">
                                                {activeTab === 'tab1' &&
                                                    <div>
                                                        {
                                                            isLoading ?
                                                                <div
                                                                    className="pt-5 pb-5 d-flex justify-center align-center">
                                                                    <LoadingState/>
                                                                </div> :
                                                                <AccountSummary/>
                                                        }
                                                    </div>
                                                }


                                                {activeTab === 'tab2' &&
                                                    <div>
                                                        {
                                                            isLoading ?
                                                                <div
                                                                    className="pt-5 pb-5 d-flex justify-center align-center">
                                                                    <LoadingState/>
                                                                </div> :
                                                                <TradeHistory/>
                                                        }
                                                    </div>
                                                }
                                                {activeTab === 'tab3' &&
                                                    <div>
                                                        {
                                                            isLoading ?
                                                                <div
                                                                    className="pt-5 pb-5 d-flex justify-center align-center">
                                                                    <LoadingState/>
                                                                </div> :
                                                                <VisualizationAnalytics/>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    profileState.roles.includes('admin') ?
                                                        <>
                                                            {activeTab === 'tab4' &&
                                                                <div>
                                                                    {
                                                                        isLoading ?
                                                                            <div
                                                                                className="pt-5 pb-5 d-flex justify-center align-center">
                                                                                <LoadingState/>
                                                                            </div> :
                                                                            <AnalyticsLogs data={{
                                                                                ...summary,
                                                                                equityOfDays: orderDetail.equity,
                                                                                highestEquity: orderDetail?.highestEquity,
                                                                                lastEquity: orderDetail?.lastEquity,
                                                                                lowestEquity: orderDetail?.lowestEquity,
                                                                                positionsStatusAtTheMomentOfTheLowestEquity: orderDetail?.positionsStatusAtTheMomentOfTheLowestEquity,
                                                                                theDatetimeAtTheMomentOfTheLowestEquity: orderDetail?.theDatetimeAtTheMomentOfTheLowestEquity,
                                                                            }}/>
                                                                    }
                                                                </div>
                                                            }
                                                        </> : ''
                                                }

                                            </div>
                                        </div>
                                }
                            </>
                    }


                </div>
            </div>
        </React.Fragment>

    );


};

export default Analytics;
